import { render, staticRenderFns } from "./InstallationOld.vue?vue&type=template&id=34e7b6cb&"
import script from "./InstallationOld.vue?vue&type=script&lang=js&"
export * from "./InstallationOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports